export const PORTAL_TABS = {
  SEARCH: 'search',
  TIMELINE: 'timeline',
  WEBHOOKS: 'webhooks',
  RECONCILIATION: 'reconciliation',
  FAILURES: 'failures',
  UNSYNCED: 'unsynced',
};

export const PORTAL_TAB_ITEMS = [
  { id: PORTAL_TABS.SEARCH, label: 'Global Search' },
  { id: PORTAL_TABS.TIMELINE, label: 'User Timeline' },
  { id: PORTAL_TABS.WEBHOOKS, label: 'Webhook Inbox' },
  { id: PORTAL_TABS.RECONCILIATION, label: 'Reconciliation' },
  { id: PORTAL_TABS.FAILURES, label: 'Failures & Alerts' },
  { id: PORTAL_TABS.UNSYNCED, label: 'Get Unsynced Users' },
];

export const PORTAL_STATUS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
  RESOLVED: 'resolved',
};
